import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  IconoirHome,
  IconoirNavArrowRight,
  IconoirLinear,
} from '@ey-xd/motif-icon';
import { MotifModule } from "@ey-xd/motif-wc-angular"; 
import { Subject, takeUntil } from 'rxjs';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';

@Component({
  selector: 'app-agent-breadcrumb',
  standalone: true,
  imports: [CommonModule, MotifModule],
  templateUrl: './agent-breadcrumb.component.html',
  styleUrl: './agent-breadcrumb.component.scss',
})
export class AgentBreadcrumbComponent {
  @Output() navigateToAgentOne = new EventEmitter<any>();

  private destroy$ = new Subject<void>();
  private _inAgentTwo!: boolean;

  @Input() showUntil: number = 5;
  @Input() inIXBRL: boolean = false;

  home: string = 'home';

  @Input()
  set inAgentTwo(value: boolean) {
    this._inAgentTwo = value;
    this.setActiveBreadcrumb();
  }

  get inAgentTwo(): boolean {
    return this._inAgentTwo;
  }

  // TODO: Scale this functionality because the navigation
  // between agent 1 and 2 is handicaped because you need
  // to go throught agent 1 first before getting to agent 2
  breadcrumbTabs: any[] = [
    {
      name: 'Trial Balance Extraction Agent',
      route: '/tb-agent',
      active: false,
    },
    {
      name: 'UK Chart of Account Mapping Agent',
      route: '/agent-two',
      active: false,
    },
    // {
    //   name: 'Agent 3',
    //   route: '/agent-three',
    //   active: false,
    // },
    // {
    //   name: 'Agent 4',
    //   route: '/agent-four',
    //   active: false,
    // },
    {
      name: 'Corporate Income Tax Review Agent',
      route: '/agent-five',
      active: false,
    },
  ];

  tabsForIXBRL: any[] = [
    // {
    //   name: 'Document Acceptance',
    //   route: '/document-acceptance',
    //   active: false,
    // },
    {
      name: 'Document Formatting',
      route: '/document-formatting',
      active: false,
    },
    // {
    //   name: 'Document Review',
    //   route: '/document-review',
    //   active: false,
    // },
  ];

  IconoirHome = IconoirHome;
  IconoirNavArrowRight = IconoirNavArrowRight;
  IconoirLinear = IconoirLinear;

  // Zoom related properties for breakpoint observer
  isZoomed: boolean = false;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private breakpointObserver: BreakpointObserver
  ) {
    this.breakpointObserver
      .observe(['(max-width: 800px)'])
      .subscribe((result) => {
        // result matches returns true if the width is <= 800px
        this.isZoomed = result.matches;
      });
  }

  ngOnInit() {
    if (this.inIXBRL) {
      this.breadcrumbTabs = this.tabsForIXBRL;
      // this.home = 'ixbrl';
    } else {
      this.manageBreadcrumbVisibility();
    }
    this.setActiveBreadcrumb();
  }

  private manageBreadcrumbVisibility() {
    this.breadcrumbTabs = this.breadcrumbTabs.splice(0, this.showUntil);
  }

  private setActiveBreadcrumb() {
    this.activatedRoute.url
      .pipe(takeUntil(this.destroy$))
      .subscribe((urlSegments) => {
        const currentPath =
          '/' + urlSegments.map((segment) => segment.path).join('/');
        this.breadcrumbTabs.forEach((tab) => {
          if (this.inAgentTwo) {
            tab.route === '/agent-two'
              ? (tab.active = true)
              : (tab.active = false);
          } else {
            tab.active = tab.route === currentPath;
          }
        });
      });
  }

  navigateTo(route: string) {
    if (this.inAgentTwo && route.toLowerCase() !== 'home') {
      // to avoid emitting if the user just wants to go home from CoA Agent
      this.navigateToAgentOne.emit();
    } else {
      this.router.navigate([route]);
    }
  }

  conditionForTabAccess(tab: {
    name: string;
    route: string;
    active: boolean;
  }): number {
    // if the tab is active (not clickable) or if the tab is the one for
    // agent 2 (not clickable as well) don't make it accessible by tab key
    return tab.active || tab.route === '/agent-two' ? -1 : 0;
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
